import { render, staticRenderFns } from "./ListSolutions.vue?vue&type=template&id=90e7d8fc&scoped=true&"
import script from "./ListSolutions.vue?vue&type=script&lang=ts&"
export * from "./ListSolutions.vue?vue&type=script&lang=ts&"
import style0 from "./ListSolutions.vue?vue&type=style&index=0&id=90e7d8fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e7d8fc",
  null
  
)

export default component.exports